import { memo } from 'react';
import cn from 'classnames';
import { Radio, RadioGroup } from '@creditflowresearch/uilib/Radio';
import useCallableFilter from './useCallableFilter';

import styles
  from '@/creditflowresearch/ui/components/corporate-bond-screener/Sidebar/Sections/styles/radioGroup.module.scss';
import spaceStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';

const CallableTranches = memo(() => {
  const { selectedValue, onChange, options } = useCallableFilter();

  return (
    <RadioGroup
      name="callableTranches"
      dataTest="callableTranchesRadioGroup"
      selectedValue={ selectedValue }
      onChange={ onChange }
      label="Callable Tranches"
      isNarrow
      className={ cn(styles.radioGroup, spaceStyles.mtl) }
    >
      { options.map((option) => (
        <Radio
          key={ option.value }
          value={ option.value }
          label={ option.label }
          dataTest={ `radio-callable-${ option.value }` }
        />
      )) }
    </RadioGroup>
  );
});

export default CallableTranches;
